import { initNewsletterConfirmPage } from './components/newsletter-confirm'

initNewsletterConfirmPage()
